/**
 * AccountPage component
 */

import React from 'react'

const AccountPage = () => (
    <>
        <p>Account page</p>
    </>
)

export { AccountPage as default }
